import { withHandlers } from 'recompose';
import { getApiDateFormat, getApiDTFormat } from 'helpers';

const withChangeHandlers = withHandlers({
  reset: ({ defaultRow, setState }) => event => {
    setState({ ...defaultRow });
  },
  cancel: ({ setEditing, setState }) => event => {
    setEditing(false);
    setState({});
  },
  handleDateChange: ({ state, setState }) => name => event => {
    setState({ ...state, [name]: getApiDateFormat(event) });
  },
  handleDateTimeChange: ({ state, setState }) => name => event => {
    setState({ ...state, [name]: getApiDTFormat(event) });
  },
  handleChange: ({ state, setState }) => event => {
    setState({ ...state, [event.target.name]: event.target.value });
  },
  handleInputChange: ({ state, setState }) => name => value => {
    setState({ ...state, [name]: value });
  },
  handleSiteChange: ({ state, setState }) => (name, event) => {
    setState({ ...state, [name]: event ? event.value : '' });
  },
  handleCountryChange: ({ state, setState }) => (name, event) => {
    setState({ ...state, [name]: event ? event.value : '', name: event ? event.name : '' });
  }
});

export { withChangeHandlers };
